import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "status-card-set__title" }
const _hoisted_2 = {
  key: 0,
  class: "status-card-set__message"
}
const _hoisted_3 = {
  key: 1,
  class: "status-card-set__status"
}

import { PropType } from 'vue'
import type { TravelInfoTitleSection } from './../../types'
import { getCurrentCulture } from './../../utilities/culture-helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceTitleArea',
  props: {
  titleInfo: {
    type: Object as PropType<TravelInfoTitleSection>,
    required: true,
  },
},
  setup(__props) {



const { cultureShortCode } = getCurrentCulture()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.titleInfo.title[_unref(cultureShortCode)]), 1 /* TEXT */),
    (
      __props.titleInfo.delayInfo.isVisible &&
      __props.titleInfo.delayInfo.message[_unref(cultureShortCode)]
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.titleInfo.delayInfo.message[_unref(cultureShortCode)]), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (
      __props.titleInfo.serviceInfo.isVisible &&
      __props.titleInfo.serviceInfo.message &&
      __props.titleInfo.serviceInfo.message[_unref(cultureShortCode)]?.length > 0
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.titleInfo.serviceInfo.message![_unref(cultureShortCode)]), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})